import React from 'react'
import { observer } from 'mobx-react'
import { LayerGroup } from 'react-leaflet'
import classnames from 'classnames'
import { turfPointToLatLng } from 'utils'
import DrawingHandle from './DrawingHandle'
import OptionalGeoJSON from './OptionalGeoJSON'
import ShapeDrawingHandleList from './ShapeDrawingHandleList'
import LineDistance from './LineDistance'

// Renders the outline and drawing handles of a shape:
// * while it's being drawn
// * after drawing is complete, but before "add" or "cancel" have been clicked
const ShapeLayer = ({ shape }) => {
  return (
    shape.drawing
      ? (
        <LayerGroup>
          {
            shape.finalPoint
              ? ([
                <DrawingHandle
                  key='point'
                  position={turfPointToLatLng(shape.finalPoint)}
                  radius={6}
                  inactive={!shape.closing}
                />,
                <LineDistance
                  key='distance'
                  position={turfPointToLatLng(shape.finalPoint)}
                  text={shape.lastTwoPointsDistance}
                />
                ])
              : null
          }
          <ShapeDrawingHandleList shape={shape} />
          <OptionalGeoJSON
            transparency={shape.transparency}
            color={shape.getColor}
            geoJSON={shape.region}
            className={classnames({
              'region-buffer': true,
              'region-buffer-too-large': shape.tooLarge,
              'region-buffer-user-drawn': true
            })}
          />
        </LayerGroup>
        )
      : (
        <LayerGroup>
          <OptionalGeoJSON
            color={shape.getColor}
            transparency={shape.transparency}
            geoJSON={shape.region}
            className={classnames({
              'region-buffer': true,
              'region-buffer-too-large': shape.tooLarge,
              'region-buffer-user-drawn': true
            })}
          />
        </LayerGroup>
        )
  )
}

export default observer(ShapeLayer)
